import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom'  
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AnalysisDashboard from './AnalysisDashboard';

const routing = (  
  <Router>
      <Routes>
      <Route path="" element={<App />} />  
      <Route path="/analysis" element={<AnalysisDashboard />} /> 
      </Routes>
  </Router>  
)  
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(routing
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
